import api from '@/api'

const state = {
  isReported: false,
  reportNum: 0,
  storeId: null,
  planTime: '',
  // 全店铺已提报，全平台未提报
  isAllStoresReported: false,
  // 全平台已提报
  isAllReported: false,
  dialogHieght: 0,
  timeType: "月"
}

const mutations = {
  // 是否已提报
  SET_ISREPORTED: (state, data) => {
    state.isReported = data
  },
  // 提报店铺数量
  SET_REPORTNUM: (state, data) => {
    state.reportNum = data
  },
  // 当前显示的店铺
  SET_STOREID: (state, data) => {
    state.storeId = data
  },
  // 当前tabs active 月份
  SET_PLANTIME: (state, data) => {
    state.planTime = data
  },
  // 当前选择的时间类型
  SET_TIMETIME: (state, data) => {
    state.timeType = data
  },
  SET_ISALLREPORTED: (state, data) => {
    state.isAllReported = data;
  },
  SET_ISALLSTORESREPORTED: (state, data) => {
    state.isAllStoresReported = data;
  },
  dialogHieght: (state, data) => {  //预览弹框拉伸动态高度
    state.dialogHieght = data;
  },
  delHieght: (state, data) => { //弹框销毁
    state.dialogHieght = 0;
  },
}

const actions = {
  // 已提报店铺数量/未提报店铺数量
  async get_reportNum({commit}, status) {
    commit('SET_ISREPORTED', status)

    let data = {
      storeId: state.storeId,
      planTime: state.planTime
    };
    let res = await api.preSalePlan.goodsSubSim({params: data});
    if(res.success) {
      commit('SET_REPORTNUM', `${res.data.subNum}/${res.data.total}`)
      // 全店铺已提报，全平台未提报
      if(res.data.subNum == res.data.total && !state.isAllReported) {
        commit('SET_ISALLSTORESREPORTED', true)
      }else{
        commit('SET_ISALLSTORESREPORTED', false)
      }
    }
  },
  // 当前显示月份是否已经全部提报
  get_isAllReported({commit}, data) {
    return api.preSalePlan.getAllIsSubmit({params: {
      planTime: state.planTime
    }})
    .then(res=>{
      commit('SET_ISALLREPORTED', res.data)
    })
  },
  set_storeId({commit},storeId) {
    commit('SET_STOREID', storeId);
  },
  set_planTime({commit}, planTime) {
    commit('SET_PLANTIME', planTime);
  },
  set_timeType({commit}, timeType) {
    commit('SET_TIMETIME', timeType);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
